export const QUOTE_TAG_NAME = 'blockquote';
export const SOURCE_TAG_NAME = 'cite';
